import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./BannerAbout.css";

export default function BannerAbout(props) {
  return (
    <Container>
      <Row md="12" className="banner-about-first-line">
        <Col lg="7">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            {props.firstText}
          </p>
        </Col>
        <Col lg="5" className="banner-about-col">
          <img
            src={props.companyBrand}
            alt="Logo Empresa"
            style={{ height: props.brandHeight }}
          />
        </Col>
      </Row>
      <Row md="12" className="banner-about-second-line">
        <Col>
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            {props.secondText}
          </p>
        </Col>
      </Row>
    </Container>
  );
}
